import {BaseComponent} from '../base.component';
import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-chapps-card',
  templateUrl: './chapps-card.component.html',
  styleUrls: ['./chapps-card.component.scss'],
})
export class ChappsCardComponent extends BaseComponent {

  @Input() userName: string;
  @Input() userEmail: string;
  @Input() logoUrl: string;
  @Output() accountClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() signOutClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    super();
  }

  public onSignOutClick() {
    this.signOutClicked.emit(null);
  }

  public onAccountClick() {
    this.accountClicked.emit(null);
  }
}
